import { Button } from "../../core/Button";

import { TRequestButtonProps } from "./PillButton.type";

export default function PillButton({ text, onClick }: TRequestButtonProps) {
  return (
    <div className="flex gap-4 px-4 py-3 bg-red-50 rounded-lg w-fit">
      <p className="text-red-400">{text}</p>
      <div
        className="cursor-pointer flex content-center items-center"
        onClick={onClick}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 0C3.14024 0 0 3.14024 0 7C0 10.8598 3.14024 14 7 14C10.8598 14 14 10.8598 14 7C14 3.14024 10.8598 0 7 0ZM9.53447 8.77322C9.58658 8.82273 9.62824 8.88216 9.65702 8.94802C9.68579 9.01388 9.70109 9.08483 9.70201 9.1567C9.70293 9.22857 9.68946 9.29989 9.66238 9.36647C9.6353 9.43304 9.59517 9.49352 9.54434 9.54434C9.49352 9.59517 9.43304 9.6353 9.36647 9.66238C9.29989 9.68946 9.22857 9.70293 9.1567 9.70201C9.08483 9.70109 9.01388 9.68579 8.94802 9.65702C8.88216 9.62824 8.82273 9.58658 8.77322 9.53447L7 7.76159L5.22678 9.53447C5.12498 9.63119 4.98942 9.68431 4.84901 9.68252C4.7086 9.68072 4.57445 9.62414 4.47515 9.52485C4.37586 9.42556 4.31928 9.2914 4.31748 9.15099C4.31569 9.01058 4.36881 8.87502 4.46553 8.77322L6.23841 7L4.46553 5.22678C4.36881 5.12498 4.31569 4.98942 4.31748 4.84901C4.31928 4.7086 4.37586 4.57445 4.47515 4.47515C4.57445 4.37586 4.7086 4.31928 4.84901 4.31748C4.98942 4.31569 5.12498 4.36881 5.22678 4.46553L7 6.23841L8.77322 4.46553C8.87502 4.36881 9.01058 4.31569 9.15099 4.31748C9.2914 4.31928 9.42556 4.37586 9.52485 4.47515C9.62414 4.57445 9.68072 4.7086 9.68252 4.84901C9.68431 4.98942 9.63119 5.12498 9.53447 5.22678L7.76159 7L9.53447 8.77322Z"
            fill="#DF6865"
          />
        </svg>
      </div>
    </div>
  );
}
